// 샘플 ERD 데이터 상수 정의
// 초급 (테이블 4개), 중급 (테이블 10개), 고급 (테이블 20개)

// 1. 초급: 블로그 및 방명록 스키마 (테이블 4개)
export const SAMPLE_BASIC = {
  dbType: 'PostgreSQL',
  canvasPan: { x: 50, y: 50 },
  canvasScale: 0.9,
  tables: [
    {
      id: 't_b_user',
      physicalName: 'tb_user',
      logicalName: '사용자 정보',
      comment: '회원 정보를 저장하는 마스터 테이블',
      x: 120,
      y: 340,
      columns: [
        { id: 'c_b_u_no', physicalName: 'user_no', logicalName: '사용자번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '사용자 일련번호' },
        { id: 'c_b_u_id', physicalName: 'user_id', logicalName: '아이디', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: true, defaultValue: '', comment: '로그인용 계정 ID' },
        { id: 'c_b_u_name', physicalName: 'user_name', logicalName: '이름', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '사용자 실명' },
        { id: 'c_b_u_created', physicalName: 'created_at', logicalName: '가입일시', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '회원 가입 일자' }
      ]
    },
    {
      id: 't_b_category',
      physicalName: 'tb_category',
      logicalName: '게시글 카테고리',
      comment: '게시글 분류를 위한 카테고리 테이블',
      x: 120,
      y: 560,
      columns: [
        { id: 'c_b_cat_no', physicalName: 'category_no', logicalName: '카테고리번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '카테고리 일련번호' },
        { id: 'c_b_cat_name', physicalName: 'category_name', logicalName: '카테고리명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '카테고리명' },
        { id: 'c_b_cat_desc', physicalName: 'description', logicalName: '설명', dataType: 'VARCHAR', size: '255', pk: false, fk: false, notNull: false, unique: false, defaultValue: '', comment: '카테고리 설명' }
      ]
    },
    {
      id: 't_b_post',
      physicalName: 'tb_post',
      logicalName: '게시글 정보',
      comment: '블로그 게시물 본문 테이블',
      x: 480,
      y: 340,
      columns: [
        { id: 'c_b_p_no', physicalName: 'post_no', logicalName: '게시글번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '게시글 일련번호' },
        { id: 'c_b_p_uno', physicalName: 'user_no', logicalName: '작성자번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '작성 회원 번호', fkRef: { tableId: 't_b_user', columnId: 'c_b_u_no' } },
        { id: 'c_b_p_catno', physicalName: 'category_no', logicalName: '카테고리번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 카테고리 번호', fkRef: { tableId: 't_b_category', columnId: 'c_b_cat_no' } },
        { id: 'c_b_p_title', physicalName: 'title', logicalName: '제목', dataType: 'VARCHAR', size: '200', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '게시글 제목' },
        { id: 'c_b_p_content', physicalName: 'content', logicalName: '본문', dataType: 'TEXT', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '게시글 본문 내용' },
        { id: 'c_b_p_created', physicalName: 'created_at', logicalName: '작성일시', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '게시글 등록 시간' }
      ]
    },
    {
      id: 't_b_comment',
      physicalName: 'tb_comment',
      logicalName: '댓글 정보',
      comment: '게시물에 달린 회원 댓글 테이블',
      x: 840,
      y: 340,
      columns: [
        { id: 'c_b_com_no', physicalName: 'comment_no', logicalName: '댓글번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '댓글 일련번호' },
        { id: 'c_b_com_pno', physicalName: 'post_no', logicalName: '게시글번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '대상 게시글 번호', fkRef: { tableId: 't_b_post', columnId: 'c_b_p_no' } },
        { id: 'c_b_com_uno', physicalName: 'user_no', logicalName: '작성자번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '댓글 작성 회원 번호', fkRef: { tableId: 't_b_user', columnId: 'c_b_u_no' } },
        { id: 'c_b_com_content', physicalName: 'content', logicalName: '내용', dataType: 'TEXT', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '댓글 본문' },
        { id: 'c_b_com_created', physicalName: 'created_at', logicalName: '작성일시', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '댓글 작성 시간' }
      ]
    }
  ],
  relationships: [
    { id: 'r_b_u_post', parentTableId: 't_b_user', parentColumnId: 'c_b_u_no', childTableId: 't_b_post', childColumnId: 'c_b_p_uno', type: '1:N' },
    { id: 'r_b_cat_post', parentTableId: 't_b_category', parentColumnId: 'c_b_cat_no', childTableId: 't_b_post', childColumnId: 'c_b_p_catno', type: '1:N' },
    { id: 'r_b_post_comment', parentTableId: 't_b_post', parentColumnId: 'c_b_p_no', childTableId: 't_b_comment', childColumnId: 'c_b_com_pno', type: '1:N' },
    { id: 'r_b_u_comment', parentTableId: 't_b_user', parentColumnId: 'c_b_u_no', childTableId: 't_b_comment', childColumnId: 'c_b_com_uno', type: '1:N' }
  ],
  stickyNotes: [
    {
      id: 's_b_group1',
      x: 70,
      y: 90,
      w: 1080,
      h: 680,
      color: '#fef08a',
      content: `# 초급: 게시판 & 블로그 ERD 샘플
이 스키마는 **회원(tb_user)**, **카테고리(tb_category)**, **게시글(tb_post)**, **댓글(tb_comment)** 등 가장 정형적이고 기초적인 웹 서비스 설계를 보여줍니다.

- 모든 테이블은 기본키(PK)로 자동 증가되는 \`SERIAL\` 타입을 사용합니다.
- 게시글 및 댓글에는 회원 정보를 담은 \`user_no\`가 외래키(FK)로 자동 릴레이션 매핑되어 있습니다.`
    }
  ]
};

// 2. 중급: 쇼핑몰 결제 및 배송 시스템 (테이블 10개)
export const SAMPLE_ECOMMERCE = {
  dbType: 'PostgreSQL',
  canvasPan: { x: 30, y: 30 },
  canvasScale: 0.8,
  tables: [
    {
      id: 't_e_user',
      physicalName: 'tb_user',
      logicalName: '회원 정보',
      comment: '회원 마스터 정보',
      x: 100,
      y: 330,
      columns: [
        { id: 'c_e_u_no', physicalName: 'user_no', logicalName: '회원번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '회원 일련번호' },
        { id: 'c_e_u_id', physicalName: 'user_id', logicalName: '아이디', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: true, defaultValue: '', comment: '회원 ID' },
        { id: 'c_e_u_name', physicalName: 'user_name', logicalName: '이름', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '회원 실명' },
        { id: 'c_e_u_email', physicalName: 'email', logicalName: '이메일', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '이메일 주소' }
      ]
    },
    {
      id: 't_e_address',
      physicalName: 'tb_user_address',
      logicalName: '배송지 목록',
      comment: '회원별 다중 배송지 주소록',
      x: 100,
      y: 530,
      columns: [
        { id: 'c_e_adr_no', physicalName: 'address_no', logicalName: '주소번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '배송지 일련번호' },
        { id: 'c_e_adr_uno', physicalName: 'user_no', logicalName: '회원번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소유 회원 번호', fkRef: { tableId: 't_e_user', columnId: 'c_e_u_no' } },
        { id: 'c_e_adr_name', physicalName: 'recipient_name', logicalName: '수령인명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '수령자 성함' },
        { id: 'c_e_adr_detail', physicalName: 'address_detail', logicalName: '상세주소', dataType: 'VARCHAR', size: '255', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '도로명 및 상세 주소' }
      ]
    },
    {
      id: 't_e_category',
      physicalName: 'tb_category',
      logicalName: '상품 카테고리',
      comment: '상품의 대/중/소 분류',
      x: 450,
      y: 330,
      columns: [
        { id: 'c_e_cat_no', physicalName: 'category_no', logicalName: '카테고리번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '카테고리 일련번호' },
        { id: 'c_e_cat_name', physicalName: 'category_name', logicalName: '카테고리명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '카테고리명' }
      ]
    },
    {
      id: 't_e_product',
      physicalName: 'tb_product',
      logicalName: '상품 정보',
      comment: '판매 상품 상세 데이터',
      x: 450,
      y: 500,
      columns: [
        { id: 'c_e_prod_no', physicalName: 'product_no', logicalName: '상품번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '상품 일련번호' },
        { id: 'c_e_prod_catno', physicalName: 'category_no', logicalName: '카테고리번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 카테고리 번호', fkRef: { tableId: 't_e_category', columnId: 'c_e_cat_no' } },
        { id: 'c_e_prod_name', physicalName: 'product_name', logicalName: '상품명', dataType: 'VARCHAR', size: '200', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '상품명' },
        { id: 'c_e_prod_price', physicalName: 'price', logicalName: '판매가격', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '0', comment: '상품 판매 단가' },
        { id: 'c_e_prod_stock', physicalName: 'stock_quantity', logicalName: '재고량', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '0', comment: '상품 재고량' }
      ]
    },
    {
      id: 't_e_cart',
      physicalName: 'tb_cart',
      logicalName: '장바구니',
      comment: '회원별 담아둔 장바구니 보관함',
      x: 100,
      y: 730,
      columns: [
        { id: 'c_e_crt_no', physicalName: 'cart_no', logicalName: '장바구니번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '장바구니 일련번호' },
        { id: 'c_e_crt_uno', physicalName: 'user_no', logicalName: '회원번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '회원 번호', fkRef: { tableId: 't_e_user', columnId: 'c_e_u_no' } },
        { id: 'c_e_crt_pno', physicalName: 'product_no', logicalName: '상품번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '상품 번호', fkRef: { tableId: 't_e_product', columnId: 'c_e_prod_no' } },
        { id: 'c_e_crt_qty', physicalName: 'quantity', logicalName: '담은수량', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '1', comment: '담은 수량' }
      ]
    },
    {
      id: 't_e_order',
      physicalName: 'tb_order',
      logicalName: '주문 마스터',
      comment: '주문 결제 마스터 정보',
      x: 800,
      y: 330,
      columns: [
        { id: 'c_e_ord_no', physicalName: 'order_no', logicalName: '주문번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '주문 마스터 일련번호' },
        { id: 'c_e_ord_uno', physicalName: 'user_no', logicalName: '회원번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '주문자 회원번호', fkRef: { tableId: 't_e_user', columnId: 'c_e_u_no' } },
        { id: 'c_e_ord_date', physicalName: 'order_date', logicalName: '주문일시', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '주문 등록 시각' },
        { id: 'c_e_ord_total', physicalName: 'total_price', logicalName: '총주문금액', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '0', comment: '총 결제 대상 금액' }
      ]
    },
    {
      id: 't_e_order_item',
      physicalName: 'tb_order_item',
      logicalName: '주문 상세 품목',
      comment: '주문서 내 품목 내역',
      x: 800,
      y: 530,
      columns: [
        { id: 'c_e_item_no', physicalName: 'order_item_no', logicalName: '주문상세번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '주문상세 일련번호' },
        { id: 'c_e_item_ono', physicalName: 'order_no', logicalName: '주문번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '부모 주문서 번호', fkRef: { tableId: 't_e_order', columnId: 'c_e_ord_no' } },
        { id: 'c_e_item_pno', physicalName: 'product_no', logicalName: '상품번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '대상 주문 상품 번호', fkRef: { tableId: 't_e_product', columnId: 'c_e_prod_no' } },
        { id: 'c_e_item_qty', physicalName: 'quantity', logicalName: '주문수량', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '1', comment: '주문 수량' },
        { id: 'c_e_item_price', physicalName: 'price', logicalName: '구매단가', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '실제 결제 단가' }
      ]
    },
    {
      id: 't_e_payment',
      physicalName: 'tb_payment',
      logicalName: '결제 내역',
      comment: '결제 트랜잭션 성공 이력',
      x: 1150,
      y: 330,
      columns: [
        { id: 'c_e_pay_no', physicalName: 'payment_no', logicalName: '결제번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '결제 일련번호' },
        { id: 'c_e_pay_ono', physicalName: 'order_no', logicalName: '주문번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: true, defaultValue: '', comment: '결제 대상 주문 번호', fkRef: { tableId: 't_e_order', columnId: 'c_e_ord_no' } },
        { id: 'c_e_pay_method', physicalName: 'payment_method', logicalName: '결제수단', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '신용카드/무통장/간편결제 등' },
        { id: 'c_e_pay_amount', physicalName: 'amount', logicalName: '결제금액', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '실제 결제 금액' },
        { id: 'c_e_pay_at', physicalName: 'paid_at', logicalName: '결제시각', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '결제 완료 시간' }
      ]
    },
    {
      id: 't_e_delivery',
      physicalName: 'tb_delivery',
      logicalName: '배송 정보',
      comment: '주문 물품 배송 추적',
      x: 1150,
      y: 560,
      columns: [
        { id: 'c_e_del_no', physicalName: 'delivery_no', logicalName: '배송번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '배송 추적 일련번호' },
        { id: 'c_e_del_ono', physicalName: 'order_no', logicalName: '주문번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: true, defaultValue: '', comment: '배송 대상 주문 번호', fkRef: { tableId: 't_e_order', columnId: 'c_e_ord_no' } },
        { id: 'c_e_del_adrno', physicalName: 'address_no', logicalName: '배송지주소번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '주소록 참조 번호', fkRef: { tableId: 't_e_address', columnId: 'c_e_adr_no' } },
        { id: 'c_e_del_status', physicalName: 'status', logicalName: '배송상태', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: false, defaultValue: "'READY'", comment: '배송준비/배송중/배송완료' },
        { id: 'c_e_del_at', physicalName: 'shipped_at', logicalName: '출고시각', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: false, unique: false, defaultValue: '', comment: '출고일시' }
      ]
    },
    {
      id: 't_e_review',
      physicalName: 'tb_review',
      logicalName: '상품 리뷰',
      comment: '상품 구매평 내역',
      x: 450,
      y: 730,
      columns: [
        { id: 'c_e_rev_no', physicalName: 'review_no', logicalName: '리뷰번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '구매평 일련번호' },
        { id: 'c_e_rev_uno', physicalName: 'user_no', logicalName: '회원번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '리뷰 작성자 번호', fkRef: { tableId: 't_e_user', columnId: 'c_e_u_no' } },
        { id: 'c_e_rev_pno', physicalName: 'product_no', logicalName: '상품번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '리뷰 상품 번호', fkRef: { tableId: 't_e_product', columnId: 'c_e_prod_no' } },
        { id: 'c_e_rev_rating', physicalName: 'rating', logicalName: '평점', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '5', comment: '별점 (1~5)' },
        { id: 'c_e_rev_content', physicalName: 'content', logicalName: '내용', dataType: 'TEXT', size: '', pk: false, fk: false, notNull: false, unique: false, defaultValue: '', comment: '리뷰 내용' }
      ]
    }
  ],
  relationships: [
    { id: 'r_e_u_adr', parentTableId: 't_e_user', parentColumnId: 'c_e_u_no', childTableId: 't_e_address', childColumnId: 'c_e_adr_uno', type: '1:N' },
    { id: 'r_e_cat_prod', parentTableId: 't_e_category', parentColumnId: 'c_e_cat_no', childTableId: 't_e_product', childColumnId: 'c_e_prod_catno', type: '1:N' },
    { id: 'r_e_u_cart', parentTableId: 't_e_user', parentColumnId: 'c_e_u_no', childTableId: 't_e_cart', childColumnId: 'c_e_crt_uno', type: '1:N' },
    { id: 'r_e_prod_cart', parentTableId: 't_e_product', parentColumnId: 'c_e_prod_no', childTableId: 't_e_cart', childColumnId: 'c_e_crt_pno', type: '1:N' },
    { id: 'r_e_u_order', parentTableId: 't_e_user', parentColumnId: 'c_e_u_no', childTableId: 't_e_order', childColumnId: 'c_e_ord_uno', type: '1:N' },
    { id: 'r_e_ord_item', parentTableId: 't_e_order', parentColumnId: 'c_e_ord_no', childTableId: 't_e_order_item', childColumnId: 'c_e_item_ono', type: '1:N' },
    { id: 'r_e_prod_item', parentTableId: 't_e_product', parentColumnId: 'c_e_prod_no', childTableId: 't_e_order_item', childColumnId: 'c_e_item_pno', type: '1:N' },
    { id: 'r_e_ord_pay', parentTableId: 't_e_order', parentColumnId: 'c_e_ord_no', childTableId: 't_e_payment', childColumnId: 'c_e_pay_ono', type: '1:N' },
    { id: 'r_e_ord_del', parentTableId: 't_e_order', parentColumnId: 'c_e_ord_no', childTableId: 't_e_delivery', childColumnId: 'c_e_del_ono', type: '1:N' },
    { id: 'r_e_adr_del', parentTableId: 't_e_address', parentColumnId: 'c_e_adr_no', childTableId: 't_e_delivery', childColumnId: 'c_e_del_adrno', type: '1:N' },
    { id: 'r_e_u_rev', parentTableId: 't_e_user', parentColumnId: 'c_e_u_no', childTableId: 't_e_review', childColumnId: 'c_e_rev_uno', type: '1:N' },
    { id: 'r_e_prod_rev', parentTableId: 't_e_product', parentColumnId: 'c_e_prod_no', childTableId: 't_e_review', childColumnId: 'c_e_rev_pno', type: '1:N' }
  ],
  stickyNotes: [
    {
      id: 's_e_group1',
      x: 70,
      y: 80,
      w: 320,
      h: 950,
      color: '#bbf7d0',
      content: `# 회원 & 배송지 데이터군
이 영역은 쇼핑몰 서비스의 기본 회원과 회원 주소록 데이터를 관리합니다.

- **tb_user** 회원 정보 테이블
- **tb_user_address** 다중 배송지 주소록`
    },
    {
      id: 's_e_group2',
      x: 420,
      y: 80,
      w: 320,
      h: 950,
      color: '#bae6fd',
      content: `# 상품 & 카테고리 정보군
제품 상세 내역과 제품별 카테고리, 그리고 구매 고객의 피드백을 모으는 리뷰 데이터를 묶어두었습니다.`
    },
    {
      id: 's_e_group3',
      x: 770,
      y: 80,
      w: 700,
      h: 950,
      color: '#fef08a',
      content: `# 주문 & 결제 & 배송 트랜잭션
주문서 작성을 중심으로 상세 품목과 실제 승인된 결제 내역, 배송 추적용 마스터 데이터를 포함한 핵심 비즈니스 도메인 영역입니다.`
    }
  ]
};

// 3. 고급: 대학 종합 학사 행정 및 복지 시스템 (테이블 20개)
export const SAMPLE_LMS = {
  dbType: 'PostgreSQL',
  canvasPan: { x: 0, y: 0 },
  canvasScale: 0.55,
  tables: [
    {
      id: 't_l_dept',
      physicalName: 'tb_department',
      logicalName: '학과 정보',
      comment: '대학 학과 마스터',
      x: 100,
      y: 330,
      columns: [
        { id: 'c_l_dept_no', physicalName: 'dept_no', logicalName: '학과번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '학과 일련번호' },
        { id: 'c_l_dept_name', physicalName: 'dept_name', logicalName: '학과명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: true, defaultValue: '', comment: '학과명' }
      ]
    },
    {
      id: 't_l_classroom',
      physicalName: 'tb_classroom',
      logicalName: '강의실 정보',
      comment: '학내 강의실 대장',
      x: 100,
      y: 480,
      columns: [
        { id: 'c_l_room_no', physicalName: 'room_no', logicalName: '강의실번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '강의실 일련번호' },
        { id: 'c_l_room_name', physicalName: 'room_name', logicalName: '강의실명', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '예: 공학관 301호' },
        { id: 'c_l_room_cap', physicalName: 'capacity', logicalName: '수용인원', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '40', comment: '수용 정원' }
      ]
    },
    {
      id: 't_l_semester',
      physicalName: 'tb_semester',
      logicalName: '학기 정보',
      comment: '개설 학기 정보',
      x: 100,
      y: 680,
      columns: [
        { id: 'c_l_sem_no', physicalName: 'semester_no', logicalName: '학기번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '학기 일련번호' },
        { id: 'c_l_sem_year', physicalName: 'year', logicalName: '연도', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '2026', comment: '개설 연도' },
        { id: 'c_l_sem_term', physicalName: 'term', logicalName: '학기구분', dataType: 'VARCHAR', size: '20', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '1학기/여름학기/2학기/겨울학기' }
      ]
    },
    {
      id: 't_l_student',
      physicalName: 'tb_student',
      logicalName: '학생 정보',
      comment: '학생 인적사항 테이블',
      x: 410,
      y: 330,
      columns: [
        { id: 'c_l_stud_no', physicalName: 'student_no', logicalName: '학생번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '학생 일련번호' },
        { id: 'c_l_stud_dept', physicalName: 'dept_no', logicalName: '소속학과번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 학과', fkRef: { tableId: 't_l_dept', columnId: 'c_l_dept_no' } },
        { id: 'c_l_stud_name', physicalName: 'name', logicalName: '이름', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '성명' },
        { id: 'c_l_stud_phone', physicalName: 'phone', logicalName: '연락처', dataType: 'VARCHAR', size: '30', pk: false, fk: false, notNull: false, unique: false, defaultValue: '', comment: '전화번호' }
      ]
    },
    {
      id: 't_l_instructor',
      physicalName: 'tb_instructor',
      logicalName: '교수 강사 정보',
      comment: '강사진 마스터 정보',
      x: 410,
      y: 550,
      columns: [
        { id: 'c_l_inst_no', physicalName: 'instructor_no', logicalName: '교수번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '교수 일련번호' },
        { id: 'c_l_inst_dept', physicalName: 'dept_no', logicalName: '소속학과번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 학과 번호', fkRef: { tableId: 't_l_dept', columnId: 'c_l_dept_no' } },
        { id: 'c_l_inst_name', physicalName: 'name', logicalName: '이름', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '교수 성함' }
      ]
    },
    {
      id: 't_l_course',
      physicalName: 'tb_course',
      logicalName: '개설 강좌 마스터',
      comment: '교육과정 상의 과목 마스터',
      x: 790,
      y: 330,
      columns: [
        { id: 'c_l_crs_no', physicalName: 'course_no', logicalName: '과목번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '과목 일련번호' },
        { id: 'c_l_crs_dept', physicalName: 'dept_no', logicalName: '개설학과번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '학과 번호', fkRef: { tableId: 't_l_dept', columnId: 'c_l_dept_no' } },
        { id: 'c_l_crs_title', physicalName: 'title', logicalName: '과목명', dataType: 'VARCHAR', size: '150', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '강좌 과목명' },
        { id: 'c_l_crs_credits', physicalName: 'credits', logicalName: '학점', dataType: 'INTEGER', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '3', comment: '이수 학점' }
      ]
    },
    {
      id: 't_l_section',
      physicalName: 'tb_section',
      logicalName: '분반 강의 세션',
      comment: '해당 학기에 개설된 과목의 실제 강의 분반',
      x: 790,
      y: 550,
      columns: [
        { id: 'c_l_sec_no', physicalName: 'section_no', logicalName: '분반번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '개설분반 일련번호' },
        { id: 'c_l_sec_cno', physicalName: 'course_no', logicalName: '과목번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '부모 강좌 번호', fkRef: { tableId: 't_l_course', columnId: 'c_l_crs_no' } },
        { id: 'c_l_sec_sno', physicalName: 'semester_no', logicalName: '학기번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '해당 학기 번호', fkRef: { tableId: 't_l_semester', columnId: 'c_l_sem_no' } },
        { id: 'c_l_sec_ino', physicalName: 'instructor_no', logicalName: '담당교수번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '담당 교수진 일련번호', fkRef: { tableId: 't_l_instructor', columnId: 'c_l_inst_no' } },
        { id: 'c_l_sec_rno', physicalName: 'room_no', logicalName: '강의실번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '수업 강의실', fkRef: { tableId: 't_l_classroom', columnId: 'c_l_room_no' } }
      ]
    },
    {
      id: 't_l_enrollment',
      physicalName: 'tb_enrollment',
      logicalName: '수강 신청 목록',
      comment: '학생별 수강 신청 내역',
      x: 1100,
      y: 330,
      columns: [
        { id: 'c_l_enr_no', physicalName: 'enrollment_no', logicalName: '수강신청번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '수강등록 일련번호' },
        { id: 'c_l_enr_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 학생 일련번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_enr_sec', physicalName: 'section_no', logicalName: '분반번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '수업 분반 일련번호', fkRef: { tableId: 't_l_section', columnId: 'c_l_sec_no' } }
      ]
    },
    {
      id: 't_l_grade',
      physicalName: 'tb_grade',
      logicalName: '이수 성적',
      comment: '신청한 과목의 학기말 성적 기록',
      x: 1100,
      y: 500,
      columns: [
        { id: 'c_l_grd_no', physicalName: 'grade_no', logicalName: '성적기록번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '성적 일련번호' },
        { id: 'c_l_grd_eno', physicalName: 'enrollment_no', logicalName: '수강신청번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: true, defaultValue: '', comment: '대상 수강 신청 번호', fkRef: { tableId: 't_l_enrollment', columnId: 'c_l_enr_no' } },
        { id: 'c_l_grd_score', physicalName: 'score', logicalName: '평점값', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '0.0', comment: '성적 학점 값 (예: 4.5)' },
        { id: 'c_l_grd_rank', physicalName: 'rank_grade', logicalName: '등급', dataType: 'VARCHAR', size: '10', pk: false, fk: false, notNull: true, unique: false, defaultValue: "'F'", comment: 'A+/B/C 등급 명칭' }
      ]
    },
    {
      id: 't_l_tuition',
      physicalName: 'tb_tuition',
      logicalName: '등록금 납부 고지',
      comment: '학생별 등록금 수납 이력',
      x: 100,
      y: 1260,
      columns: [
        { id: 'c_l_tui_no', physicalName: 'tuition_no', logicalName: '등록금번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '등록금 고지 일련번호' },
        { id: 'c_l_tui_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '대상 학생 일련번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_tui_amount', physicalName: 'amount', logicalName: '고지액', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '등록금 청구 금액' },
        { id: 'c_l_tui_status', physicalName: 'is_paid', logicalName: '납부여부', dataType: 'BOOLEAN', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'FALSE', comment: '납부 완료 상태' }
      ]
    },
    {
      id: 't_l_scholarship',
      physicalName: 'tb_scholarship',
      logicalName: '장학금 내역',
      comment: '장학 수혜 등록 대장',
      x: 450,
      y: 1260,
      columns: [
        { id: 'c_l_sch_no', physicalName: 'scholarship_no', logicalName: '장학번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '장학금 수혜 번호' },
        { id: 'c_l_sch_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '수혜 대상 학생', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_sch_name', physicalName: 'scholarship_name', logicalName: '장학명칭', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '장학명' },
        { id: 'c_l_sch_amount', physicalName: 'amount', logicalName: '장학지원액', dataType: 'NUMERIC', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '장학 지원금' }
      ]
    },
    {
      id: 't_l_advisor',
      physicalName: 'tb_advisor',
      logicalName: '교수 상담 일지',
      comment: '지도교수-학생 매핑 및 상담 대장',
      x: 800,
      y: 1260,
      columns: [
        { id: 'c_l_adv_no', physicalName: 'advisor_no', logicalName: '상담상태번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '상담 배정 일련번호' },
        { id: 'c_l_adv_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: true, defaultValue: '', comment: '대상 지도 학생', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_adv_ino', physicalName: 'instructor_no', logicalName: '교수번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '지정 지도 교수', fkRef: { tableId: 't_l_instructor', columnId: 'c_l_inst_no' } }
      ]
    },
    {
      id: 't_l_club',
      physicalName: 'tb_club',
      logicalName: '학내 동아리',
      comment: '정식 등록된 동아리 정보',
      x: 1470,
      y: 330,
      columns: [
        { id: 'c_l_clb_no', physicalName: 'club_no', logicalName: '동아리번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '동아리 일련번호' },
        { id: 'c_l_clb_name', physicalName: 'club_name', logicalName: '동아리명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: true, defaultValue: '', comment: '동아리 명칭' }
      ]
    },
    {
      id: 't_l_club_member',
      physicalName: 'tb_club_member',
      logicalName: '동아리 회원 목록',
      comment: '동아리 가입 신청자 및 회원 매핑',
      x: 1470,
      y: 500,
      columns: [
        { id: 'c_l_cmem_no', physicalName: 'member_no', logicalName: '가입번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '동아리회원 일련번호' },
        { id: 'c_l_cmem_clb', physicalName: 'club_no', logicalName: '동아리번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 동아리 번호', fkRef: { tableId: 't_l_club', columnId: 'c_l_clb_no' } },
        { id: 'c_l_cmem_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '소속 학생 번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } }
      ]
    },
    {
      id: 't_l_dorm',
      physicalName: 'tb_dormitory',
      logicalName: '기숙사 거주 정보',
      comment: '기숙사 관실 입소 대장',
      x: 1470,
      y: 700,
      columns: [
        { id: 'c_l_dorm_no', physicalName: 'dormitory_no', logicalName: '기숙사번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '기숙사 거주 일련번호' },
        { id: 'c_l_dorm_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: true, defaultValue: '', comment: '입소 학생 번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_dorm_room', physicalName: 'room_name', logicalName: '호실명', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '호실정보 (예: B동 402호)' }
      ]
    },
    {
      id: 't_l_book',
      physicalName: 'tb_library_book',
      logicalName: '도서관 도서 대장',
      comment: '도서관 보유 단행본 대장',
      x: 1800,
      y: 330,
      columns: [
        { id: 'c_l_bk_no', physicalName: 'book_no', logicalName: '도서등록번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '도서관 일련번호' },
        { id: 'c_l_bk_title', physicalName: 'title', logicalName: '도서명', dataType: 'VARCHAR', size: '200', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '도서 제목' },
        { id: 'c_l_bk_author', physicalName: 'author', logicalName: '저자', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '지은이' }
      ]
    },
    {
      id: 't_l_loan',
      physicalName: 'tb_book_loan',
      logicalName: '도서 대출 내역',
      comment: '학생별 대출 및 반납 추적 레코드',
      x: 1800,
      y: 500,
      columns: [
        { id: 'c_l_loan_no', physicalName: 'loan_no', logicalName: '대출번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '대출 이력 일련번호' },
        { id: 'c_l_loan_bk', physicalName: 'book_no', logicalName: '도서번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '대출된 도서 번호', fkRef: { tableId: 't_l_book', columnId: 'c_l_bk_no' } },
        { id: 'c_l_loan_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '대출자 학생 일련번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_loan_date', physicalName: 'loan_date', logicalName: '대출일시', dataType: 'TIMESTAMP', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: 'CURRENT_TIMESTAMP', comment: '대출 시작 시간' }
      ]
    },
    {
      id: 't_l_facility',
      physicalName: 'tb_facility_booking',
      logicalName: '강의 시설물 예약',
      comment: '학내 세미나실 및 운동시설 예약 관리',
      x: 1800,
      y: 720,
      columns: [
        { id: 'c_l_fac_no', physicalName: 'booking_no', logicalName: '예약번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '예약 일련번호' },
        { id: 'c_l_fac_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '예약 학생 번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_fac_name', physicalName: 'facility_name', logicalName: '시설물명', dataType: 'VARCHAR', size: '100', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '학내 강당/체육관 등 명칭' },
        { id: 'c_l_fac_date', physicalName: 'booking_date', logicalName: '예약희망일', dataType: 'DATE', size: '', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '예약 날짜' }
      ]
    },
    {
      id: 't_l_notif',
      physicalName: 'tb_notification',
      logicalName: '시스템 알림 보관함',
      comment: '학생별 실시간 정보/학사안내 알림',
      x: 1470,
      y: 1260,
      columns: [
        { id: 'c_l_ntf_no', physicalName: 'notification_no', logicalName: '알림번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '알림 일련번호' },
        { id: 'c_l_ntf_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '알림 수신인', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_ntf_msg', physicalName: 'message', logicalName: '알림메시지', dataType: 'VARCHAR', size: '255', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: '알림 본문 내용' }
      ]
    },
    {
      id: 't_l_log',
      physicalName: 'tb_member_log',
      logicalName: '학사 활동 로그',
      comment: '학생 및 교수 활동 시스템 감사 로그',
      x: 1800,
      y: 1260,
      columns: [
        { id: 'c_l_log_no', physicalName: 'log_no', logicalName: '로그번호', dataType: 'SERIAL', size: '', pk: true, fk: false, notNull: true, unique: true, defaultValue: '', comment: '로그 일련번호' },
        { id: 'c_l_log_sno', physicalName: 'student_no', logicalName: '학생번호', dataType: 'INTEGER', size: '', pk: false, fk: true, notNull: true, unique: false, defaultValue: '', comment: '활동 주체 학생 번호', fkRef: { tableId: 't_l_student', columnId: 'c_l_stud_no' } },
        { id: 'c_l_log_act', physicalName: 'action_type', logicalName: '작업명', dataType: 'VARCHAR', size: '50', pk: false, fk: false, notNull: true, unique: false, defaultValue: '', comment: 'LOGIN/LOGOUT/REGISTER 등' }
      ]
    }
  ],
  relationships: [
    { id: 'r_l_d_stud', parentTableId: 't_l_dept', parentColumnId: 'c_l_dept_no', childTableId: 't_l_student', childColumnId: 'c_l_stud_dept', type: '1:N' },
    { id: 'r_l_d_inst', parentTableId: 't_l_dept', parentColumnId: 'c_l_dept_no', childTableId: 't_l_instructor', childColumnId: 'c_l_inst_dept', type: '1:N' },
    { id: 'r_l_d_crs', parentTableId: 't_l_dept', parentColumnId: 'c_l_dept_no', childTableId: 't_l_course', childColumnId: 'c_l_crs_dept', type: '1:N' },
    { id: 'r_l_c_sec', parentTableId: 't_l_course', parentColumnId: 'c_l_crs_no', childTableId: 't_l_section', childColumnId: 'c_l_sec_cno', type: '1:N' },
    { id: 'r_l_s_sec', parentTableId: 't_l_semester', parentColumnId: 'c_l_sem_no', childTableId: 't_l_section', childColumnId: 'c_l_sec_sno', type: '1:N' },
    { id: 'r_l_i_sec', parentTableId: 't_l_instructor', parentColumnId: 'c_l_inst_no', childTableId: 't_l_section', childColumnId: 'c_l_sec_ino', type: '1:N' },
    { id: 'r_l_r_sec', parentTableId: 't_l_classroom', parentColumnId: 'c_l_room_no', childTableId: 't_l_section', childColumnId: 'c_l_sec_rno', type: '1:N' },
    { id: 'r_l_stud_enr', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_enrollment', childColumnId: 'c_l_enr_sno', type: '1:N' },
    { id: 'r_l_sec_enr', parentTableId: 't_l_section', parentColumnId: 'c_l_sec_no', childTableId: 't_l_enrollment', childColumnId: 'c_l_enr_sec', type: '1:N' },
    { id: 'r_l_enr_grd', parentTableId: 't_l_enrollment', parentColumnId: 'c_l_enr_no', childTableId: 't_l_grade', childColumnId: 'c_l_grd_eno', type: '1:N' },
    { id: 'r_l_stud_tui', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_tuition', childColumnId: 'c_l_tui_sno', type: '1:N' },
    { id: 'r_l_stud_sch', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_scholarship', childColumnId: 'c_l_sch_sno', type: '1:N' },
    { id: 'r_l_stud_adv', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_advisor', childColumnId: 'c_l_adv_sno', type: '1:N' },
    { id: 'r_l_inst_adv', parentTableId: 't_l_instructor', parentColumnId: 'c_l_inst_no', childTableId: 't_l_advisor', childColumnId: 'c_l_adv_ino', type: '1:N' },
    { id: 'r_l_clb_memb', parentTableId: 't_l_club', parentColumnId: 'c_l_clb_no', childTableId: 't_l_club_member', childColumnId: 'c_l_cmem_clb', type: '1:N' },
    { id: 'r_l_stud_memb', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_club_member', childColumnId: 'c_l_cmem_sno', type: '1:N' },
    { id: 'r_l_stud_dorm', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_dorm', childColumnId: 'c_l_dorm_sno', type: '1:N' },
    { id: 'r_l_bk_loan', parentTableId: 't_l_book', parentColumnId: 'c_l_bk_no', childTableId: 't_l_loan', childColumnId: 'c_l_loan_bk', type: '1:N' },
    { id: 'r_l_stud_loan', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_loan', childColumnId: 'c_l_loan_sno', type: '1:N' },
    { id: 'r_l_stud_fac', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_facility', childColumnId: 'c_l_fac_sno', type: '1:N' },
    { id: 'r_l_stud_ntf', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_notif', childColumnId: 'c_l_ntf_sno', type: '1:N' },
    { id: 'r_l_stud_log', parentTableId: 't_l_student', parentColumnId: 'c_l_stud_no', childTableId: 't_l_log', childColumnId: 'c_l_log_sno', type: '1:N' }
  ],
  stickyNotes: [
    {
      id: 's_l_group1',
      x: 70,
      y: 80,
      w: 650,
      h: 900,
      color: '#bbf7d0',
      content: `# 1. 학사 및 인적정보 관리
학과 마스터 정보와 소속 학생, 교수 강사 및 기본 학사 일정(학기, 강의실) 대장입니다.`
    },
    {
      id: 's_l_group2',
      x: 760,
      y: 80,
      w: 650,
      h: 900,
      color: '#bae6fd',
      content: `# 2. 강좌 & 강의 세션 & 수강 관리
개설 과목과 분반 정보, 학생들의 수강 신청 및 최종 획득 성적 내역을 매핑합니다.`
    },
    {
      id: 's_l_group3',
      x: 70,
      y: 1040,
      w: 1340,
      h: 480,
      color: '#fef08a',
      content: `# 3. 학사 파이낸셜 및 상담 기록
등록금 고지 내역과 납부 여부, 장학금 지원 대장, 그리고 매칭된 지도교수의 전문 상담 일지입니다.`
    },
    {
      id: 's_l_group4',
      x: 1440,
      y: 80,
      w: 710,
      h: 900,
      color: '#fed7aa',
      content: `# 4. 대학 동아리 및 기숙사/도서관 복지
학내 커뮤니티(동아리 정보 및 가입 부원 목록)와 기숙사 배정 내역, 도서관 장서 대장 및 학생 대출 이력, 시설물 예약을 총망라하는 부가 학생복지 스키마군입니다.`
    },
    {
      id: 's_l_group5',
      x: 1440,
      y: 1040,
      w: 710,
      h: 480,
      color: '#fbcfe8',
      content: `# 5. 시스템 정보 및 감사로그
학생들에게 전송되는 알림과 행정 시스템 내 회원 활동 감사용 로그 테이블입니다.`
    }
  ]
};
